import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-update-available-dialog',
  imports: [MatDialogModule, MatButtonModule, TranslocoDirective],
  templateUrl: './update-available-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateAvailableDialogComponent {
  protected allowDelay = inject<boolean>(MAT_DIALOG_DATA);
}
